import React, { Component } from "react";

import FormTitle from "../FormTitle/FormTitle";
import FormStyleOfPlanBox from "./FormStyleOfPlanBox/FormStyleOfPlanBox";
import classes from "./FormStyleOfPlan.module.scss";
import classicPlan from "../../assets/images/classicPlan.png";
import miniPlan from "../../assets/images/icon_smallplans.svg";
import flexiblePlan from "../../assets/images/flexiblePlan.png";
import ballparkAccess from "../../assets/images/ballparkAccess.png";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import * as CONSTANT from "../../constants/routes";
import { withRouter } from "react-router-dom";

class FormStyleOfPlan extends Component {
  componentDidMount() {
    this.props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_2_KEY]: "",
      [ROUTES.PAGE_3_KEY]: "",
      // [ROUTES.PAGE_4_KEY]: {},
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
      // benefitSubmit: false
    });
    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      //TODO:  set default for style of plan commnent after page is active
      // this.props.updateMultipleSelectedChoices({
      //   formStyle: CONSTANT.PAGE_2_CHOICES_1,
      //   planType: "premier",
      // });

      //TODO: uncomment when suppressing style of plan and comment adobe line below
      // this.props.history.push("/size-of-plan");

      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan",
        });
      }
    }
  }
  render() {
    return (
      <div>
        <div>
          <FormTitle title="Choose the style of your plan" />
          <div className={classes.FormStyleOfPlan}>
            <FormStyleOfPlanBox
              icon={classicPlan}
              iconStyle={{ maxWidth: "50px" }}
              title="Season Plans"
              startingPrice="Starting at $20 per game, plus a $20 per seat processing fee"
              description="Lock in some of the best seats in the house for whichever set of games you choose. Season Plans include our most exclusive benefits."
              buttonName="Select"
              // buttonName="Check Back Later!"
              buttonLink="size-of-plan"
              perksLevel="3"
              updateSelectedChoices={() => {
                if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                  window.adobeAnalytics.tl(
                    true,
                    "o",
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan: classic plans : select button click",
                    {
                      prop12: "Nationals TicketFinder",
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan",
                      prop14: "classic plans : select button click",
                    }
                  );
                }
                this.props.updateMultipleSelectedChoices({
                  formStyle: CONSTANT.PAGE_2_CHOICES_1,
                  planType: "premier",
                });
              }}
            />
            {/* <FormStyleOfPlanBox
              icon={miniPlan}
              iconStyle={{ maxWidth: "57px" }}
              title="Pick 'Em Plans"
              startingPrice="Starting at $22 per game, plus a $25-40 processing fee"
              description="Unlock the flexibility to attend games that fit your schedule, selecting the games and seats you want as the season goes on."
              buttonName="Select"
              // buttonName="Check Back Later!"
              buttonLink="size-of-plan"
              perksLevel="2"
              updateSelectedChoices={() => {
                if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                  window.adobeAnalytics.tl(
                    true,
                    "o",
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan: Pick 'Em Plans : select button click",
                    {
                      prop12: "Nationals TicketFinder",
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan",
                      prop14: "Pick 'Em Plans : select button click",
                    }
                  );
                }
                this.props.updateMultipleSelectedChoices({
                  formStyle: CONSTANT.PAGE_2_CHOICES_2,
                  planType: "pickem",
                });
              }}
            /> */}
            {/* <FormStyleOfPlanBox
              icon={flexiblePlan}
              iconStyle={{ maxWidth: "50px" }}
              title="Mini Plans"
              startingPrice="Starting at $24 per game, plus a $12.50 per seat processing fee"
              description="Choose from plans as small as 5 games, featuring some of our most exciting rivalries and giveaways."
              // buttonName="Select"
              buttonName="Check Back Later!"
              buttonLink="size-of-plan"
              perksLevel="3"
              updateSelectedChoices={() => {
                if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                  window.adobeAnalytics.tl(
                    true,
                    "o",
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan: classic plans : select button click",
                    {
                      prop12: "Nationals TicketFinder",
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan",
                      prop14: "classic plans : select button click",
                    }
                  );
                }
                this.props.updateMultipleSelectedChoices({
                  formStyle: CONSTANT.PAGE_2_CHOICES_1,
                  planType: "small",
                });
              }}
            /> */}
            <FormStyleOfPlanBox
              icon={ballparkAccess}
              iconStyle={{ maxWidth: "57px" }}
              title="Ballpark Access"
              startingPrice="$6 PER GAME, PLUS A $7 PER PASS PROCESSING FEE"
              description="Enjoy the game from any Standing Room location, including bars and restaurants throughout Nationals Park."
              buttonName="Select"
              // buttonName="Check Back Later!"
              buttonLink="size-of-plan"
              perksLevel="1"
              updateSelectedChoices={() => {
                if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                  window.adobeAnalytics.tl(
                    true,
                    "o",
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan: ballpark access : select button click",
                    {
                      prop12: "Nationals TicketFinder",
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Style of plan",
                      prop14: "ballpark access : select button click",
                    }
                  );
                }

                this.props.updateMultipleSelectedChoices({
                  formStyle: CONSTANT.PAGE_2_CHOICES_3,
                  planType: "ballpark",
                });
              }}
            />
          </div>
        </div>
        <FormController
          backTo={ROUTES.PAGE_1_LINK}
          nextTo={ROUTES.PAGE_3_LINK}
          startOver={ROUTES.PAGE_1_LINK}
          showBack={true}
          showStartOver={false}
          showSkip={false}
          showSubmit={false}
        />
      </div>
    );
  }
}

export default withRouter(FormStyleOfPlan);
